// import React from 'react'

// function user() {
//   return (
//     <div>

//     </div>
//   )
// }

// export default user


// import React from 'react'

// function Order() {
//   return (
//     <div>Order</div>
//   )
// }

// export default Order


import React, { useEffect, useState } from 'react'
import { Col, Container, Offcanvas, Row } from 'react-bootstrap'
import Loading from './Loading'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AddHeader from '../components/AddHeader/AddHeader'
import FilterContainer from '../components/FilterContainer/FilterContainer'
import UserInfo from '../components/UserInfo/UserInfo'
import CustomTable from '../components/CustomTable/CustomTable'
import VisibilityIcon from '@mui/icons-material/Visibility'
import InvoiceContainer from '../components/InvoiceContainer/InvoiceContainer';

function User() {
  const [order, setOrder] = useState([])
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false);
  const { id } = useParams()
  const userinfo = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const { list: users } = useSelector((state) => state.users);
    const user = users.find(item => item.id == id);
console.log(user);

  const header = [
    { id: "id", numeric: false, disablePadding: true, label: currentLocal.home.ID },
        { id: "trackingNumber", numeric: true, disablePadding: false, label:currentLocal.home.trackingNumber},
    { id: "date", numeric: true, disablePadding: false, label:  currentLocal.home.date},
    { id: "Totalamount", numeric: true, disablePadding: false, label: currentLocal.home.Totalamount},
      { id: "orderStatus", numeric: true, disablePadding: false, label: currentLocal.home.orderStatus},

    { id: "actions", numeric: true, disablePadding: false, label: currentLocal.home.actions },

  ];
const myData =user?.orders?.map((item) => {
  console.log(item);
  
  return {
    id: item?.id,
    trackingNumber:item?.order_no||"------",
    date:item?.created_at?.slice(0,10)||"------",
    Totalamount:item?.total+currentLocal.home.egp||"------",
    orderStatus:item.status?.id==3?"proccing":item?.status?.id==4?"shipped":item?.status?.id==5?"Delivered":"Pending"||"------",
    actions: (
      <div className='d-flex align-items-center'>
        <div 
          className='d-flex align-items-center' 
          style={{ cursor: "pointer" }} 
          onClick={() => navigate(`/dashboard/order/${item?.id}`)}
        >
          <VisibilityIcon
            sx={{ 
              color: '#6C757D', 
              fontSize: '1rem', 
              marginLeft: '5px',
              marginRight: '5px' // أضف مسافة بسيطة من الجهة الأخرى أيضاً
            }}
          />
          <p className='mb-0' style={{ fontSize: '1rem', color: '#6C757D' }}>
            {currentLocal.home.Preview}
          </p>
        </div>
        <div>
                <InvoiceContainer
            trackingNumber={item?.order_no}
            createdAt={item && item?.created_at && item?.created_at.substring(0, 10)}
            total={item?.total}
            paymentMethod={item?.payment_method}
            address1={item?.address?.notes}
            subtotal={item?.subtotal}
            name={item?.client?.name}
            address2={
              item?.address
                ? `${item?.address.house_number || ""}, ${item?.address.block || ""}, ${item?.address.street || ""}`
                : ""
            }
            phone={item?.client?.phone}
            city={item?.address?.city?.name}
            region={item?.address?.region}
            street={item?.address?.street}
            block={item?.address?.block}
            house_number={item?.address?.house_number}
            items={item?.details}
            shippingAmount={item?.delivery_fee}

          />
        </div>
      </div>
    )
  };
});

  return (
    loading ?
      <Loading />
      :
      <div className='outlit_bg px-4'>
        <AddHeader
          title={currentLocal.home.Customer}
          text={""}
        />
        <FilterContainer
          exportexcel={false}
          searchState={false}
        />
        <>
          <UserInfo users={users} />
      {user?.orders?.length>0&&
            <div className='mx-4'>
              <CustomTable
                headCells={header}
                rows={myData} />
            </div>
      }

        </>
      </div>
  )
}

export default User